import { v4 as uuidv4 } from 'uuid';

export function ProductImages(props = {}, childrenComponents = []) {
	return {
		componentName: 'ProductImages',
		componentId: uuidv4(),
		props: Object.assign(
			{
				aspectRatio: 'auto',
				contentOrder: 'images-first',
				displayThumbnailsArrows: false,
				placeholder: '',
				hiddenImages: 'skuvariation',
				maxHeight: 450,
				position: 'left',
				showNavigationArrows: 'always',
				showPaginationDots: 'always',
				thumbnailVisibility: 'visible',
				thumbnailAspectRatio: 'auto',
				thumbnailsOrientation: 'vertical',
				zoomFactor: 2,
				zoomMode: 'in-place-click',
				contentType: 'all',
				displayMode: 'carousel',
				blockClass: 'images-pr',
			},
			props,
		),
		childrenComponents,
	};
}
